"use strict";
// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAvailable = void 0;
const restapi_1 = require("./restapi");
Object.defineProperty(exports, "isAvailable", { enumerable: true, get: function () { return restapi_1.isAvailable; } });
//# sourceMappingURL=terminal.js.map